<template>
  <div class="value-item">
    <slot name="icon"></slot>
    <div class="title" v-html="title"></div>
    <div class="desc">{{ desc }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
      required: true,
    },
    desc: {
      type: String,
      default: "",
      required: true,
    },
  },
};
</script>

<style scoped>
.value-item {
  border-radius: 8px;
  border: 1px solid #d9dbdf;
  background: #fff;
  width: 100%;
  padding: 32px;
  text-align: center;
}

.title {
  color: #1f2329;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  margin-top: 32px;
  margin-bottom: 16px;
}

.desc {
  color: #50627f;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 170%;
}

@media screen and (max-width: 1000px) {
  .value-item {
    text-align: left !important;
    padding: 16px !important;
  }

  .value-item .title {
    font-size: 16px !important;
    margin-top: 16px !important;
    margin-bottom: 8px !important;
  }

  .value-item .disc {
    font-size: 14px !important;
    line-height: 100%;
  }

  img {
    width: 40px !important;
    height: 40px !important;
  }
}
</style>
